import React from "react";

const Footer = () => {
  return (
    <footer>
      <p>
        ©2025 POWERED BY <a href="https://mpesa-pay-nine.vercel.app/">CONFRONTER TECH</a>
      </p>
    </footer>
  );
};

export default Footer;
